import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import DemandSheet from "@/components/DemandSheet";
import { getPropertyDemandLink } from "@/services/demandService";
import "./PropertyDemandPage.scss";

export const streetOf = (property) =>
  property?.street || [property?.city, property?.state].filter(Boolean).join(", ") || "your home";

const PropertyDemandPage = () => {
  const { token } = useParams();
  const query = useQuery({
    queryKey: ["propertyDemandPage", token],
    queryFn: () => getPropertyDemandLink(token),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  const data = query.data?.result;

  useEffect(() => {
    document.title = data ? `Real-time demand for ${streetOf(data.property)} | Gitcha` : "Real-time demand | Gitcha";
  }, [data]);

  return (
    <main className="property-demand-page">
      {query.isLoading ? (
        <p className="property-demand-page__state" aria-busy="true">
          Loading real-time demand…
        </p>
      ) : !data && query.isError && query.error?.response?.status !== 404 ? (
        <div className="property-demand-page__gone">
          <h1>We could not load this&nbsp;page</h1>
          <p>Check your connection and try again.</p>
          <button type="button" className="btn btn-primary" onClick={() => query.refetch()}>
            Try again
          </button>
        </div>
      ) : !data ? (
        <div className="property-demand-page__gone">
          <h1>This link is no longer&nbsp;available</h1>
          <p>Ask your agent for a new&nbsp;link.</p>
        </div>
      ) : (
        <DemandSheet
          title={`Real-time demand for ${streetOf(data.property)}`}
          countLine="Buyer Want‑Listings from local agents that match your home"
          demand={data.demand}
          howWeCount={`We count live Buyer Want‑Listings from local agents whose budget, area and must-haves match your home. Counts are ranges and never name a buyer or their agent. ${
            data.agent?.firstName || "Your agent"
          } can tell you more about these buyers.`}
          agent={data.agent}
          branding={data.branding}
          generatedAt={data.generatedAt}
        />
      )}
    </main>
  );
};

export default PropertyDemandPage;
